<template>
	<div>
		<modal ref="usuario_ativar">
			<div class="row">
				<div class="col-xs-12">
					<i class="fa fa-check"></i> {{ _traducao('global', 'ativarUsuario').toUpperCase() }}
					<hr />
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12 text-center">
					<h2>{{ _traducao('global', 'desejaAtivarEsseUsuario').toUpperCase() }}</h2>
					<h3 class="text-success" style="margin: 20px 0 20px 0; font-weight: bold">{{ form.nome.toUpperCase() }}</h3>
					<hr />
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12">
					<button type="button" @click="$refs.usuario_ativar.modalHide()" class="btn btn-default pull-left">
						<i class="fa fa-times fa-fw"></i>{{ _traducao('global', 'cancelar').toUpperCase() }}
					</button>
					<button type="button" @click="ativarUsuario()" class="col-md-2 btn btn-success pull-right">
						<i class="fa fa-check-circle"></i> {{ _traducao('global', 'ativar').toUpperCase() }}
					</button>
				</div>
			</div>
		</modal>
	</div>
</template>
<script>
export default {
	props: ['form'],

	methods: {
		carregaModalAtivar() {
			this.$refs.usuario_ativar.modalShow(60)
		},

		ativarUsuario() {
			bus.$emit('load-in', {text: 'Ativando Usuário'})

			this._httpGet('Usuario/ativa/' + this.form.id, (retorno) => {
				bus.$emit('load-out')

				if (retorno._status && retorno._request) {
					this.$refs.usuario_ativar.modalHide()
					this.$emit('ativado', retorno.lista[0])
				} else {
					bus.$emit('exibir-notificacao', {text: 'Não foi possivel ativar usuário'})
				}
			})
		}
	}
}
</script>